export const FilterTypeLayout = {
  FILTER_RANGE: "range",
  FILTER_GRID: "grid",
  FILTER_ON_SALE: "on_sale",
};
